import React, { useEffect, useState } from "react";
import axios from "axios";
import configData from "../../config/config.json";

export default function LoginPageLinksSmall({ bare }) {
    const [paragraphs, setParagraphs] = useState([]);

    useEffect(() => {
        const loadLinks = async () => {
            try {
                const response = await axios.get(configData.LANDNOTIFICATION_SERVER_URL + "auth/loginPageLinks?language=" + 'ENGLISH', { withCredentials: true });
                setParagraphs(response.data.content.paragraphs);
            } catch (error) {
                console.error("Failed to load links:", error);
            }
        };

        loadLinks();
    }, []);

    return (
        <div style={bare ? styles.bareLinksContainer : styles.linksContainer}>
        {!bare && <h3 style={styles.linksTitle}>Useful Links</h3>}
            {paragraphs.map((paragraph) => (
                <a
                    key={paragraph.paragraphContent}
                    href={paragraph.paragraphContent}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={bare ? styles.bareLink : styles.link}
                >
                    {paragraph.heading}
                </a>
            ))}
        </div>

    );
}

const styles = {
linksContainer: {
    marginTop: "20px",
    width: "100%",
    boxSizing: "border-box",
    padding: "16px",
background:
    "linear-gradient(180deg, #114E6B 0%, #2A6E8B 100%)",
    boxShadow: "0 4px 12px rgba(17, 78, 107, 0.12)",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    borderRadius: "8px",
},


link: {
    display: "block",
    padding: "8px 0",
    color: "#FFFFFF",
    textDecoration: "underline",
    fontWeight: "bold",
    fontSize: "14px",
},

bareLinksContainer: {
    width: "100%",
    boxSizing: "border-box",
    padding: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
},

bareLink: {
    display: "block",
    padding: "8px 0",
    color: "#114E6B",
    textDecoration: "underline",
    fontWeight: "bold",
    fontSize: "14px",
},

linksTitle: {
  color: "#FFFFFF",
  fontSize: "18px",
  fontWeight: "700",
  margin: "0 0 16px 0",
},


};